var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 3.75C4.625 3.90625 4.625 4.125 4.78125 4.28125L8.4375 7.90625C8.59375 8.0625 8.84375 8.0625 8.96875 7.90625L9.1875 7.6875C9.34375 7.53125 9.34375 7.3125 9.1875 7.15625L6 4L9.21875 0.875C9.34375 0.71875 9.34375 0.5 9.21875 0.34375L8.96875 0.125C8.84375 -0.03125 8.59375 -0.03125 8.4375 0.125L4.78125 3.75ZM0.78125 4.28125L4.4375 7.90625C4.59375 8.0625 4.84375 8.0625 4.96875 7.90625L5.21875 7.6875C5.34375 7.53125 5.34375 7.3125 5.21875 7.15625L2 4L5.1875 0.875C5.34375 0.71875 5.34375 0.5 5.1875 0.34375L4.96875 0.125C4.84375 -0.03125 4.59375 -0.03125 4.4375 0.125L0.78125 3.75C0.625 3.90625 0.625 4.125 0.78125 4.28125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDoubleRight);
export default __webpack_public_path__ + "static/media/angle-double-right.6f65a3a0.svg";
export { ForwardRef as ReactComponent };